import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';

const VERIFY_EMAIL_URL = `${import.meta.env.VITE_APP_API_URL}/verify-email`;

const EmailVerify = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Token aus den Query-Parametern lesen
  const token = new URLSearchParams(location.search).get('token');

  useEffect(() => {
    if (!token) {
      enqueueSnackbar('Ungültiger oder fehlender Token. Weiterleitung zum Login.', {
        variant: 'error'
      });
      navigate('/auth/login');
      return;
    }

    // API-Aufruf zur Verifizierung der E-Mail-Adresse
    const verifyEmail = async () => {
      try {
        const response = await fetch(VERIFY_EMAIL_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token })
        });

        if (response.ok) {
          const result = await response.json();
          enqueueSnackbar(result.message || 'E-Mail-Adresse erfolgreich bestätigt.', {
            variant: 'success'
          });
          navigate('/auth/email-verified');
        } else {
          const error = await response.json();
          enqueueSnackbar(
            error.detail || 'Die Verifizierung der E-Mail-Adresse ist fehlgeschlagen.',
            { variant: 'error' }
          );
          navigate('/auth/login');
        }
      } catch {
        enqueueSnackbar(
          'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut. 1',
          { variant: 'error' }
        );
        navigate('/auth/login');
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-900 mb-2.5">E-Mail wird bestätigt</h3>
        <p className="text-gray-600">
          Bitte warten Sie einen Moment, während wir Ihre E-Mail-Adresse überprüfen …
        </p>
      </div>
    </div>
  );
};

export { EmailVerify };
